import type { App } from 'vue';
import { ref } from 'vue';

const locale = ref<'en' | 'fr' | 'es'>((localStorage.getItem('locale') as 'en' | 'fr' | 'es') || 'en');

const translations: Record<string, Record<string, string>> = {};

async function loadTranslations(lang: 'en' | 'fr' | 'es') {
    try {
        const module = await import(`../../../lang/${lang}.json`);
        translations[lang] = module.default;
    } catch (error) {
        console.error(`Failed to load translations for ${lang}:`, error);
    }
}

export function useTranslation() {
    return {
        locale,
        t: (key: string) => {
            const keys = key.split('.');
            let value: any = translations[locale.value] || {};

            for (const k of keys) {
                value = value?.[k];
            }

            return value || key;
        },
        setLocale: async (newLocale: 'en' | 'fr' | 'es') => {
            if (!translations[newLocale]) {
                await loadTranslations(newLocale);
            }
            locale.value = newLocale;
            localStorage.setItem('locale', newLocale);
        },
    };
}

export default {
    install(app: App) {
        const translation = useTranslation();

        app.provide('translation', translation);
        app.config.globalProperties.$t = translation.t;
        app.config.globalProperties.$locale = locale;
    },
};
